/** student/roles — API. */
import { http } from '../../_shared/http';
import type { RoleDefinition } from './types';

export const studentRolesApi = {
  list: () => http.get<RoleDefinition[]>('/roles'),
};
